import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { getFunctions, httpsCallable } from 'firebase/functions';
import toast from 'react-hot-toast';
import firebaseApp from '../../firebase';
import { useAuth } from '../../context/AuthContext';
import { useAdmin } from '../../context/AdminContext';

const functions = getFunctions(firebaseApp, 'us-central1');

const AdminRoute = ({ children }) => {
  const { currentUser } = useAuth();
  const { isAdmin, loading } = useAdmin();
  const [bootstrapping, setBootstrapping] = useState(false);

  const runBootstrap = async () => {
    setBootstrapping(true);
    try {
      const fn = httpsCallable(functions, 'bootstrapFirstAdmin');
      await fn({});
      toast.success('Admin access granted — reloading');
      setTimeout(() => window.location.reload(), 800);
    } catch (err) {
      toast.error(err.message || 'Bootstrap failed');
    } finally {
      setBootstrapping(false);
    }
  };

  if (!currentUser) {
    return <Navigate to="/" replace />;
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface-50">
        <div className="w-8 h-8 border-4 border-canopy border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!isAdmin) {
    return (
      <div className="max-w-md mx-auto mt-16 card p-8 text-center">
        <h1 className="page-title mb-2">Admin access required</h1>
        <p className="page-subtitle mb-6">
          This page is restricted to platform admins.
          If your email is on the bootstrap allowlist, you can grant yourself access.
        </p>
        <button
          onClick={runBootstrap}
          disabled={bootstrapping}
          className="btn-primary w-full"
        >
          {bootstrapping ? 'Granting…' : 'Grant me admin access'}
        </button>
      </div>
    );
  }

  return children;
};

export default AdminRoute;
